import { Button, Label, ListBox, ListBoxItem, Popover, Select, SelectValue } from 'react-aria-components';
import { ChevronDown } from '@untitledui/icons';

export default function FinanceSelect({label,value,onChange,options}:{label:string;value:string;onChange:(value:string)=>void;options:Record<string,string>}) {
  return <Select className="finance-select" selectedKey={value} onSelectionChange={key=>onChange(String(key))}>
    <Label>{label}</Label><Button><SelectValue/><ChevronDown aria-hidden="true"/></Button>
    <Popover className="finance-select-popover"><ListBox>{Object.entries(options).map(([id,text])=><ListBoxItem id={id} key={id} textValue={text}>{text}</ListBoxItem>)}</ListBox></Popover>
  </Select>;
}
